export default "60d9f34bbaba69be.png"